module.exports = __webpack_public_path__ + "static/media/folder-open.2ed4def1.svg";